// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-customer-modal-modal_card-N32L4 {
  width: 564px;
  height: 772px;
}

.add-customer-modal-modal_content-CmaLo {
  overflow: scroll;
  padding: 0px 14px 0px 24px;
}

.add-customer-modal-customerTitle-TcdMt {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  font-size: 15px;
  margin-top: 26px;
}

.add-customer-modal-businessTitle-vyJT6 {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  font-size: 15px;
  margin-top: 40px;
}

.add-customer-modal-fieldsContent-Ur7BM {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.add-customer-modal-textField_container-juYFV, .add-customer-modal-select_container-lIeP9 {
  width: 240px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/add-customer-modal/add-customer-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 564px;\n  height: 772px;\n}\n\n.modal_content {\n  overflow: scroll;\n  padding: 0px 14px 0px 24px;\n}\n\n.customerTitle {\n  color: rgba(0, 0, 0, 0.9);\n  font-weight: 500;\n  font-size: 15px;\n  margin-top: 26px;\n}\n\n.businessTitle {\n  color: rgba(0, 0, 0, 0.9);\n  font-weight: 500;\n  font-size: 15px;\n  margin-top: 40px;\n}\n\n.fieldsContent {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n\n.textField_container, .select_container {\n  width: 240px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-customer-modal-modal_card-N32L4`,
	"modal_content": `add-customer-modal-modal_content-CmaLo`,
	"customerTitle": `add-customer-modal-customerTitle-TcdMt`,
	"businessTitle": `add-customer-modal-businessTitle-vyJT6`,
	"fieldsContent": `add-customer-modal-fieldsContent-Ur7BM`,
	"textField_container": `add-customer-modal-textField_container-juYFV`,
	"select_container": `add-customer-modal-select_container-lIeP9`
};
export default ___CSS_LOADER_EXPORT___;
